// extracted by mini-css-extract-plugin
module.exports = {"container":"PasswordSuccessRecovery_container__oFmQQ","slide-up":"PasswordSuccessRecovery_slide-up__1yynj"};